import { round } from 'lodash'

function getFormattedNumber(num, locale = 'en', fixedDecimalPlaces = true) {
	// biome-ignore lint/suspicious/noGlobalIsNan: <>
	if (!num || isNaN(num)) return num
	let formattedNum = num
	if (fixedDecimalPlaces && num) {
		formattedNum = round(num, 2).toFixed(2)
	}
	switch (locale) {
		case 'fr':
			return formattedNum
				.toString()
				.replace('.', ',')
				.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
		default:
			return formattedNum
				.toString()
				.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	}
}

export function getCompactFormattedNumber(num, locale = 'en') {
	// biome-ignore lint/suspicious/noGlobalIsNan: <>
	if (!num || isNaN(num)) return num
	let compactNum = num / 1000
	if (!compactNum || compactNum < 0.1) return getFormattedNumber(num, locale)

	if (compactNum) compactNum = round(compactNum, 2).toFixed(1)
	switch (locale) {
		case 'fr':
			return compactNum
				.toString()
				.replace(' ', ',')
				.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
				.concat('k')

		default:
			return compactNum
				.toString()
				.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
				.concat('k')
	}
}

export default getFormattedNumber
